"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import type { ReactNode } from "react";
import { Suspense } from "react";
import { AdminSidebar } from "@/components/admin-sidebar/admin-sidebar";
import { AppSidebar } from "@/components/app-sidebar/app-sidebar";
import { AssistantPanelProvider } from "@/components/assistant/assistant-panel";
import { DashboardPage } from "@/components/dashboard/dashboard-page";
import { EnforceOrganization } from "@/components/enforce-organization";
import { PageWrapperLoading } from "@/components/page-wrapper";
import { SupportDialogProvider } from "@/components/support/support-dialog";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { extractOrganizationSlug, getRelativeOrganizationPath } from "@/lib/organization-path";
interface AppShellProps {
  children: ReactNode;
  defaultSidebarOpen?: boolean;
}
export function AppShell(t0) {
  const $ = _c(22);
  const {
    children,
    defaultSidebarOpen
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname) {
    t1 = pathname.startsWith("/admin");
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isAdminRoute = t1;
  let t2;
  let t3;
  if ($[2] !== children || $[3] !== isAdminRoute || $[4] !== pathname) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const organizationSlug = extractOrganizationSlug(pathname);
      const isOrganizationRoute = Boolean(organizationSlug);
      if (!isAdminRoute && !isOrganizationRoute) {
        t3 = children;
        break bb0;
      }
      t2 = organizationSlug && getRelativeOrganizationPath(organizationSlug, pathname) === "/" ? <DashboardPage organizationSlug={organizationSlug} pending={true} /> : <PageWrapperLoading />;
    }
    $[2] = children;
    $[3] = isAdminRoute;
    $[4] = pathname;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  const loadingFallback = t2;
  let t4;
  if ($[7] !== children || $[8] !== isAdminRoute || $[9] !== loadingFallback) {
    t4 = isAdminRoute ? children : <Suspense fallback={loadingFallback}><EnforceOrganization loadingFallback={loadingFallback}>{children}</EnforceOrganization></Suspense>;
    $[7] = children;
    $[8] = isAdminRoute;
    $[9] = loadingFallback;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const content = t4;
  let t5;
  if ($[11] !== isAdminRoute) {
    t5 = isAdminRoute ? <Suspense><AdminSidebar /></Suspense> : <AppSidebar />;
    $[11] = isAdminRoute;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== content) {
    t6 = <SidebarInset className="bg-background min-h-0 overflow-hidden">{content}</SidebarInset>;
    $[13] = content;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== defaultSidebarOpen || $[16] !== t5 || $[17] !== t6) {
    t7 = <SidebarProvider className="h-screen overflow-hidden" defaultOpen={defaultSidebarOpen}>{t5}{t6}</SidebarProvider>;
    $[15] = defaultSidebarOpen;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const shell = t7;
  let t8;
  if ($[19] !== isAdminRoute || $[20] !== shell) {
    t8 = <SupportDialogProvider>{isAdminRoute ? shell : <AssistantPanelProvider>{shell}</AssistantPanelProvider>}</SupportDialogProvider>;
    $[19] = isAdminRoute;
    $[20] = shell;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}